import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import frontImage from '../images/landingpage/autosure-mechanical-breakdown-insurance-diagram.webp';
import carImage from '../images/landingpage/MBI_family_in_car_compressed_desktop.jpg';
import "../landingpage.css";
import {detectSource} from "../utils/sourceDetection";
import {useFeature} from '../hooks/useFeature';
import gaspyLearnMore from '../images/gaspy-learn-more.jpg';
import gaspyGetAQuote from '../images/gaspy-get-a-quote.png';
import {useSearchParams} from 'react-router-dom';

const MBILandingPage = ({onGetQuote}) => {
  const source = detectSource();
  const baseUrl = window.location.origin;
  const gaspyPromoEnabled = useFeature('gaspy-free-fuel-promo');
  const [, setSearchParams] = useSearchParams();
  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, #2b4d99 0%, #1e3a7a 100%)',
      padding: '0',
      position: 'relative',
      overflow: 'hidden'
    },
    heroOverlay: {
      backgroundColor: 'rgba(43, 77, 153, 0.85)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    heroContent: {
      position: 'relative',
      zIndex: 2,
      padding: '60px 20px',
      maxWidth: '800px',
      margin: '0 auto',
      textAlign: 'left'
    },
    heroTitle: {
      color: 'white',
      fontSize: '42px',
      fontWeight: 'bold',
      marginBottom: '20px',
      lineHeight: '1.2'
    },
    heroText: {
      color: 'white',
      fontSize: '18px',
      marginBottom: '30px',
      lineHeight: '1.5'
    },
    primaryButton: {
      backgroundColor: '#2b4d99',
      color: 'white',
      padding: '15px 40px',
      border: 'none',
      borderRadius: '4px',
      fontSize: '18px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'background-color 0.3s'
    },
    sectionPadding: {
      // padding: '60px 20px'
      paddingBottom: '20px',
      paddingTop: '20px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    sectionTitle: {
      fontSize: '32px',
      color: '#333',
      marginBottom: '30px',
      fontWeight: 'bold'
    },
    bodyText: {
      fontSize: '16px',
      color: '#666',
      lineHeight: '1.6',
      marginBottom: '20px'
    },
    carDiagram: {
      position: 'relative',
      display: 'inline-block',
      margin: '40px 0'
    },
    carShape: {
      width: '400px',
      height: '200px',
      backgroundColor: '#e6e6fa',
      borderRadius: '50px',
      position: 'relative',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    carBody: {
      width: '200px',
      height: '80px',
      backgroundColor: '#4a69bd',
      borderRadius: '40px 40px 20px 20px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    costIndicator: {
      position: 'absolute',
      backgroundColor: '#2b4d99',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    coverTable: {
      backgroundColor: 'white',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    },
    tableHeader: {
      display: 'flex',
      backgroundColor: '#2b4d99'
    },
    tableHeaderCell: {
      flex: 1,
      padding: '15px',
      color: 'white',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    tableRow: {
      display: 'flex'
    },
    tableCell: {
      flex: 1,
      padding: '15px',
      textAlign: 'center'
    },
    tableCellLabel: {
      flex: 1,
      padding: '15px',
      fontWeight: 'bold'
    },
    customerReview: {
      backgroundColor: '#f8f9fa',
      padding: '30px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '20px'
    },
    reviewAvatar: {
      width: '60px',
      height: '60px',
      backgroundColor: '#2b4d99',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '20px',
      fontWeight: 'bold',
      flexShrink: 0
    },
    faqItem: {
      borderBottom: '1px solid #ddd',
      padding: '20px 0'
    },
    faqQuestion: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer'
    },
    link: {
      color: '#2b4d99',
      textDecoration: 'underline'
    },
    footer: {
      backgroundColor: '#e6e6e6',
      padding: '20px',
      textAlign: 'center',
      fontSize: '12px'
    },
    logo: {
      width: '80px',
      height: '30px',
      backgroundColor: '#2b4d99',
      margin: '10px auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold'
    }
  };
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {

    window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Page View',
        virtualUrl: `${baseUrl}/mbi/step0`,
        pageTitle: 'Landing Page',
      });

  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const badge = document.querySelector(".grecaptcha-badge");

      if (badge) {
        badge.style.display = "none";
        clearInterval(interval);
      }
    }, 300);

    return () => {
      clearInterval(interval);
      const badge = document.querySelector(".grecaptcha-badge");
      if (badge) badge.style.display = "block";
    };
  }, []);

  const handleGetQuote = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mbiAutosureEvent',
      category: 'Submit',
      status: 'Success',
      virtualUrl: `${baseUrl}/mbi/step0`,
      pageTitle: 'Landing Page',
    });
    onGetQuote();
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const coverageData = [
    { label: 'Max individual claim*', advantage: '$5,000', plus: '$10,000' },
    { label: 'Parts & labour cover', advantage: 'Yes', plus: 'Yes' },
    { label: 'Additional components', advantage: 'N/A', plus: 'Yes' },
    { label: 'Consumable items', advantage: 'N/A', plus: '$750' },
    { label: 'Car repatriation', advantage: '$250', plus: '$500' },
    { label: 'Accommodation & travel', advantage: '$500', plus: '$1,500' }
  ];

  const faqData = [
    {
      question:  'What is mechanical breakdown insurance?',
      answer: "Mechanical breakdown insurance cover generally includes the reasonable cost to repair the failure of certain mechanical or electrical parts that is not a result of general wear and tear. It provides protection for unexpected repair costs on components like the engine, transmission, or other critical systems, and can include towing, roadside assistance, car repatriation, accommodation and car hire allowances or travel costs, up to certain levels if your claim is accepted. Mechanical breakdown insurance is different from comprehensive car insurance, which is for things like accidents and theft. Comprehensive car insurance does not provide cover for breakdowns. Limits, conditions and exclusions apply, so always check the policy wording."
    },
    {
      question:   'Does regular car insurance cover mechanical failure?',
      answer: "No, regular car insurance (including comprehensive policies) does not cover mechanical failure. In New Zealand, comprehensive car insurance typically covers accidental damage, theft and fire, natural disasters and third-party property damage. However, it excludes coverage for mechanical breakdowns (e.g. engine or transmission failure) or electrical faults. To protect against unexpected mechanical or electrical failures, many Kiwi drivers choose to take out mechanical breakdown insurance (MBI)."
    },
    {
      question:  'What does it cover?',
      answer: `
      <p>Mechanical breakdown insurance (MBI) covers the cost of repairs or replacement of selected major vehicle components that fail due to mechanical or electrical faults – not due to accidents, wear and tear or lack of maintenance.</p>

      <p>It typically includes:</p>

      <ul>
        <li>Engine and transmission</li>
        <li>Electrical systems</li>
        <li>Steering and suspension</li>
        <li>Fuel systems</li>
        <li>Cooling systems</li>
        <li>Braking systems</li>
        <li>Drive axles and differential</li>
      </ul>
      <p>MBI is designed to protect you from unexpected repair bills once your manufacturer's warranty expires. Many policies, including Autosure's, include roadside assistance and other additional benefits. Coverage varies by provider, so it's important to check the specific terms, exclusions, and claim process.</p>
    `
    },
    {
      question: 'How much does it cost?',
      answer:  `
    <p>In New Zealand, the cost of mechanical breakdown insurance (MBI) varies depending on several factors:</p>

    <ul>
      <li>Make and model of your vehicle</li>
      <li>Age and mileage</li>
      <li>Length of cover (usually 1 to 4 years)</li>
      <li>Level of excess you choose</li>
      <li>Type of vehicle (petrol, diesel, hybrid, or electric)</li>
    </ul>

    <p><strong>Note:</strong> The premium for the full length of cover must be paid in a single payment.</p>

    <p>The potential cost of breakdown repairs is worth considering when looking at the cost of MBI.</p>
  `
    },
    {
      question:  'Is it worth it?',
      answer: `<p>Yes, mechanical breakdown insurance (MBI) can be very valuable if you own a used car, especially if it has high mileage or is out of manufacturer warranty. It can save money on costly repairs like transmission or engine issues.</p>

<p>In New Zealand, MBI may cover major mechanical and electrical failures that aren't included in standard car insurance. Repairs like transmission issues, ECU failures, or engine faults can cost thousands of dollars, and MBI may help reduce the financial impact by covering these costs. It's important to find a policy that suits your car and budget.</p>`
 }
  ];

  return (
    <div>
      {/* Hero Section */}
      <div>
        <br/><br/>
        {/* Blue Header Bar */}
        <div style={{
          backgroundColor: source === "GASPY" ? "#ffd126" : '#2b4d99',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h1 style={{
            color: source === "GASPY" ? 'black' : 'white',
            fontSize: '32px',
            fontWeight: 'bold',
            margin: 0
          }}>
            Mechanical Breakdown Insurance
          </h1>
        </div>

        {/* Hero Banner */}
        <div style={{
          padding: 0
        }}>
          {source === 'GASPY' && gaspyPromoEnabled ? (
            <div
              onClick={() => {
                setSearchParams({utm_medium: 'st0', utm_source: 'conmbi', utm_campaign: 'promoff', utm_content: 'b1'});
                handleGetQuote();
              }}
              style={{
                backgroundColor: '#FCBE1F',
                display: 'flex',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
            >
              <img
                src={gaspyGetAQuote}
                alt="Free Fuel with Gaspy MBI - Limited Time Offer"
                style={{
                  maxHeight: '400px',
                  maxWidth: '100%',
                  height: 'auto',
                  width: 'auto',
                  display: 'block',
                }}
              />
            </div>
          ) : (
            <img
              src={carImage}
              alt="Family in car"
              style={{
                width: '100%',
                maxHeight: window.innerWidth <= 768 ? '72px' : '450px',
                objectPosition: 'center 55%',
                height: 'auto',
                // maxHeight: window.innerWidth <= 768 ? '115%' : '600px',
                // height: window.innerWidth <= 768 ? '72px' : 'auto', // zoom in on mobile
                display: 'block',
                objectFit: 'cover',
              }}
            />
          )}
        </div>

        {/* Gray Content Section */}
        <div style={{
          backgroundColor: '#f5f5f5',
          padding: '40px 20px'
        }}>
          <Container>
            <Row>
              <Col lg={10} className="mx-auto">
                {source === 'GASPY' && gaspyPromoEnabled ? (
                  <>
                    <h2 className="fs-3 fw-bold mb-3" >
                      FREE FUEL with Gaspy Mechanical Breakdown Insurance
                    </h2>
                    <p style={{ ...styles.bodyText, marginBottom: '16px' }}>
                      Drive with confidence and get rewarded while you're at it.
                    </p>
                    <p style={{ ...styles.bodyText, marginBottom: '16px' }}>
                      For a limited time, when you purchase a new Gaspy Advantage or Advantage Plus Mechanical Breakdown Insurance policy online, you'll receive a <strong>FREE MTA Gift Voucher</strong> to help cover fuel, servicing, repairs, tyres and more.
                    </p>
                    <p style={{ ...styles.bodyText, marginBottom: '30px' }}>
                      Whether you're commuting daily, heading away for weekends, or simply wanting extra peace of mind on the road, Gaspy Mechanical Breakdown Insurance helps protect you from unexpected repair costs - while this offer helps put a little money back in your pocket.
                    </p>

                    <button
                      onClick={() => {
                        setSearchParams({utm_medium: 'st0', utm_source: 'conmbi', utm_campaign: 'promoff', utm_content: 'b2'});
                        handleGetQuote();
                      }}
                      className="text-white border-0 rounded-1 fs-6 fw-bold d-block"
                      style={{ backgroundColor: '#2b4d99', padding: '12px 24px', marginBottom: '40px' }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a7a'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#2b4d99'}
                    >
                      Quote & Buy
                    </button>

                    <h3 className="fs-4 fw-bold" style={{ marginBottom: '12px' }}>
                      The Offer
                    </h3>
                    <p style={{ ...styles.bodyText, marginBottom: '8px' }}>
                      Purchase a Gaspy Advantage or Advantage Plus Mechanical Breakdown Insurance policy online between
                      18 May 2026 and
                      15 June 2026, and after the first 30 days of cover we'll send you:</p>
                    <ul className="fs-6 text-muted ps-3 lh-lg mb-4">
                      <li><strong>$50 MTA Gift Voucher with a 1-year policy</strong></li>
                      <li><strong>$100 MTA Gift Voucher with a 2-year policy</strong></li>
                      <li><strong>$150 MTA Gift Voucher with a 3-year policy</strong></li>
                    </ul>

                    <h3 className="fs-4 fw-bold" style={{ marginBottom: '12px' }}>
                      How It Works
                    </h3>
                    <ol className="fs-6 text-muted ps-3 lh-lg mb-2">
                      <li>Choose a new qualifying Gaspy Mechanical Breakdown Insurance policy online</li>
                      <li>Select your preferred policy term and buy your policy</li>
                      <li>Receive your MTA Gift Voucher after your eligibility is confirmed</li>
                    </ol>

                    <ul className="fs-6 text-muted ps-3 mb-3 lh-lg" >
                      <li>One MTA Gift Voucher per policy.</li>
                      <li><a href="https://mta.org.nz/shop/terms-and-conditions" target="_blank" rel="noopener noreferrer" style={styles.link}>Terms and conditions of MTA Gift Vouchers</a> apply, including where you can use them and terms relating to giving change.</li>
                      <li>Your policy must have been in force for 30 days to receive the MTA Gift Voucher. If you request cancellation after this, you will not be entitled to a refund.</li>
                      <li>See policy wordings for full policy terms, conditions, limits and exclusions.</li>
                    </ul>

                    <p id="gaspy-promo-tcs" className="fs-6 mb-0">
                      <a href="https://autosure.co.nz/gaspy-free-fuel-promo-tcs" target="_blank" rel="noopener noreferrer" style={styles.link}>
                        View full Gaspy Free Fuel Promotion Terms and Conditions
                      </a>
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{
                      fontSize: '16px',
                      color: '#666',
                      marginBottom: '30px',
                      lineHeight: '1.6'
                    }}>
                      Protect your car and your savings with Advantage and Advantage Plus Mechanical Breakdown Insurance.
                      Buy online in less than 3 mins.
                    </p>

                    <button
                      onClick={handleGetQuote}
                      style={{
                        backgroundColor: '#2b4d99',
                        color: 'white',
                        padding: '12px 24px',
                        border: 'none',
                        borderRadius: '4px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        marginBottom: '30px',
                        display: 'block'
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a7a'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#2b4d99'}
                    >
                      Quote & Buy
                    </button>

                    <p style={{
                      fontSize: '16px',
                      color: '#666',
                      lineHeight: '1.6',
                      margin: 0
                    }}>
                      {source === "GASPY"
                        ? "We offer extensive cover, with optional add-ons, designed to help you pay for repairs when things go wrong, so you can get back on the road fast."
                        : "Autosure offers extensive cover, with optional add-ons, designed to help you pay for repairs when things go wrong, so you can get back on the road fast."
                      }
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* What is MBI Section */}
      <div style={{ backgroundColor: 'white', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>
                What is Mechanical Breakdown Insurance (MBI)?
              </h2>

              <p style={styles.bodyText}>
                MBI provides financial protection if your car has a breakdown. It can give you peace of mind and fewer
                financial surprises after a breakdown.
              </p>

              <p style={styles.bodyText}>
                Cars today are complex and have so many mechanical and electrical components that can be expensive to
                repair when they go wrong.
              </p>

              <p style={styles.bodyText}>
                We understand that sinking feeling when your car has a breakdown. We're here to help with unexpected
                repair bills, to get your car fixed and you back on the road again.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Car Diagram Section */}
      <div style={{paddingLeft: '20px',paddingRight: '20px' }}>
        <Container>
          <Row>
            <Col className="text-center">
              <div style={styles.carDiagram}>
                <div style={{
                  position: 'relative',
                  display: 'inline-block',
                  maxWidth: '600px',
                  margin: '0 auto'
                }}>
                  {/* Car Image */}
                  <img
                    src={frontImage}
                    alt="Car breakdown diagram"
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxWidth: '500px'
                    }}
                  />

                  {/* Cost indicators positioned around the car */}

                </div>
              </div>

              <p style={{ fontSize: '12px', color: '#666' }}>
                Images and amounts are for illustrative purposes only. Underwriting criteria apply. Repair costs
                (based on 2023/4 claims) vary for make/model <b>and not all components are covered by all policies.</b>
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Key Benefits Section */}
      <div style={{ backgroundColor: 'white', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>
                {source === "GASPY"
                  ? "Key benefits of Gaspy Advantage & Advantage Plus MBI"
                  : "Key benefits of Autosure Advantage & Advantage Plus MBI"}
              </h2>

              <ul style={{ fontSize: '16px', color: '#666', lineHeight: '2', paddingLeft: '20px' }}>
                <li>Comprehensive parts and labour cost</li>
                <li>Petrol and diesel cars, EVs and hybrids</li>
                <li>Towing of your car</li>
                <li>Leading claims team and repairers</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Cover Types Table */}
      <div style={{...styles.sectionPadding}}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="comparison-container">
              <table className="comparison-table">
                <thead>
                <tr>
                  <th style={{backgroundColor: source === "GASPY" ? "#ffd126" : '#2b4d99'}}></th>
                  <th style={{
                    backgroundColor: source === "GASPY" ? "#ffd126" : '#2b4d99',
                    color: source === "GASPY" ? 'black' : "white"
                  }}>Advantage
                  </th>
                  <th style={{
                    backgroundColor: source === "GASPY" ? "#ffd126" : '#2b4d99',
                    color: source === "GASPY" ? 'black' : "white"
                  }}>Advantage Plus
                  </th>
                </tr>
                </thead>

                <tbody>
                {/* Blank top row */}
                <tr className="blank-row">
                  <td colSpan="3"></td>
                </tr>

                <tr>
                  <td> <b>Max individual claim*</b></td>
                  <td>$5,000</td>
                  <td>$10,000 - $15,000</td>
                </tr>

                <tr>
                  <td><b>Access & comfort</b></td>
                  <td>N/A</td>
                  <td>Yes</td>
                </tr>

                <tr>
                  <td><b>Assistance & safety</b></td>
                  <td>N/A</td>
                  <td>Yes</td>
                </tr>

                <tr>
                  <td><b>Entertainment</b></td>
                  <td>N/A</td>
                  <td>Yes</td>
                </tr>

                <tr>
                  <td><b>Performance</b></td>
                  <td>N/A</td>
                  <td>Yes</td>
                </tr>

                <tr>
                  <td><b>Towing</b></td>
                  <td>$300 per claim</td>
                  <td>$300 per claim</td>
                </tr>

                <tr>
                  <td><b>EV & hybrid battery cover</b></td>
                  <td>$2,500 - $5,000</td>
                  <td>$5,000 - $10,000</td>
                </tr>

                {/* SECTION HEADER */}
                <tr className="section-header">
                  <td colSpan="3">Additional Cover Options</td>
                </tr>

                <tr>
                  <td><b>AA Roadside</b></td>
                  <td>Available</td>
                  <td>Available</td>
                </tr>

                <tr>
                  <td><b>Consumable items</b></td>
                  <td>$300 per claim</td>
                  <td>$300 per claim</td>
                </tr>

                <tr>
                  <td><b>Travel disruption</b></td>
                  <td>$1,200 per claim</td>
                  <td>$1,200 per claim</td>
                </tr>

                </tbody>
              </table>
              </div>


              <p style={{ fontSize: '12px', color: '#666', marginTop: '20px' }}>
                * Claim limits depend on make and model. The total of all claims is limited to the vehicle's market value.

              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Important Information Section */}
      <div style={{ backgroundColor: 'white', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>Important information</h2>

              <ul style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', paddingLeft: '20px', marginBottom: '30px' }}>
                <li>Cover periods available: 1 – 3 years.</li>
                <li>Your responsibilities: Vehicle servicing and maintenance.</li>
                <li>Excess: You can reduce your premium by increasing your excess.</li>
                <li>Exclusions: See the policy wording What You Are Not Insured For section.</li>
                <li>Cancellations: Cancel within the first 30 days for a full refund, if you haven't made a claim.</li>
              </ul>

              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', marginBottom: '20px' }}>
                Eligibility criteria depend on vehicle age and kms at time of insurance purchase, and are subject to vehicle make and model.
              </p>

              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6' }}>
                This is a summary only. See the policy wording for full terms, conditions, exclusions, limits and benefits. This is not financial advice.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Policy Documents Section */}
      <div style={{...styles.sectionPadding}}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>Policy documents</h2>

              <p style={styles.bodyText}>
                You can download the full policy wording below to understand exactly what's covered and excluded:
              </p>

              <ul style={{ fontSize: '16px', color: '#2b4d99', lineHeight: '1.8', paddingLeft: '20px' }}>
                <li><a href={source === "GASPY" ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/gaspy_advantage.pdf" : "https://docs.autosure.co.nz/policy_books/autosure/mbi/advantage.pdf"} target="_blank" rel="noopener noreferrer" style={styles.link}>Advantage Mechanical Breakdown Insurance</a></li>
                <li><a href={source === "GASPY" ? "https://docs.autosure.co.nz/policy_books/autosure/mbi/gaspy_advantageplus.pdf" : "https://docs.autosure.co.nz/policy_books/autosure/mbi/advantage_plus.pdf"} target="_blank" rel="noopener noreferrer" style={styles.link}>Advantage Plus Mechanical Breakdown Insurance</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Customer Review Section */}
      <div style={{ backgroundColor: 'white', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col md={10} className="mx-auto">
              <div style={styles.customerReview}>
                <div style={styles.reviewAvatar}>
                  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="48" fill="#1e3d8f" stroke="#2E5C8A" stroke-width="2"/>

                    <circle cx="50" cy="38" r="14" fill="white"/>

                    <path
                      d="M 50 52 C 35 52, 25 58, 25 70 L 25 75 C 25 80, 30 85, 50 85 C 70 85, 75 80, 75 75 L 75 70 C 75 58, 65 52, 50 52 Z"
                      fill="white"/>
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#ffa500', fontSize: '18px', marginBottom: '10px' }}>⭐⭐⭐⭐⭐</div>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6', marginBottom: '10px' }}>
                    Best breakdown insurance and service based on my experience. One of the few companies who make the
                    claim process easy for the customer! Highly recommend.
                  </p>
                  <p style={{ fontSize: '14px', color: '#2b4d99', fontWeight: 'bold' }}>Paul R</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Final CTA Section */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '80px 20px' }}>
        <Container>
          <Row>
            <Col md={8} className="mx-auto text-center">
              <h2 style={styles.sectionTitle}>Get a quote</h2>

              <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', marginBottom: '20px' }}>
                Ready to protect your car with MBI?
              </p>
              {source !== "GASPY" && (
              <p style={styles.bodyText}>
                Get a quote today and discover why thousands of drivers choose Autosure for reliable, comprehensive cover.
              </p>)}

              <button
                onClick={handleGetQuote}
                style={styles.primaryButton}
                onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a7a'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#2b4d99'}
              >
                Quote & Buy
              </button>
            </Col>
          </Row>
        </Container>
      </div>

      {/* FAQ Section */}
      <div style={{ backgroundColor: 'white', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>MBI FAQs</h2>

              <div style={{ borderTop: '1px solid #ddd' }}>
                {faqData.map((item, index) => (
                  <div key={index} style={styles.faqItem}>

                    <div
                      style={styles.faqQuestion}
                      onClick={() => toggleFAQ(index)}
                    >
                      <h3 style={{fontSize: '16px', color: '#2b4d99', margin: 0, fontWeight: 'bold'}}>
                        {item.question}
                      </h3>

                      <span style={{ fontSize: '20px', color: '#666', cursor: 'pointer' }}>
          {openIndex === index ? "−" : "+"}
        </span>
                    </div>

                    {/* Answer section */}
                    {openIndex === index && (
                      <div
                        style={{ marginTop: '10px', color: '#444', fontSize: '15px' }}
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                    )}

                  </div>
                ))}
              </div>

            </Col>
          </Row>
        </Container>
      </div>

      {/* Helpful Links Section */}
      <div style={{ backgroundColor: '#f8f9fa', ...styles.sectionPadding }}>
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <h2 style={styles.sectionTitle}>Helpful links</h2>

              <ul style={{ fontSize: '16px', color: '#2b4d99', lineHeight: '2', paddingLeft: '20px', listStyle: 'disc' }}>
                <li><a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleGetQuote();
                  }}
                  style={styles.link}
                >Quote & buy online</a></li>
                {source !== "GASPY" && (<li><a href="https://autosure.co.nz/help-support/contact-us/" target="_blank"
                                               rel="noopener noreferrer" style={styles.link}>How can I contact you to
                  find out more?</a></li>)}
                <li><a href="https://autosure.co.nz/claims/mechanical-breakdown-insurance-claims/" target="_blank" rel="noopener noreferrer" style={styles.link}>How do I make a claim?</a></li>
                <li><a href="https://autosure.co.nz/about-us/ " target="_blank" rel="noopener noreferrer" style={styles.link}>How can I find out more about Autosure?</a></li>
              </ul>

              <div style={{ marginTop: '40px', fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                <p>
                  These policies are underwritten by Autosure Insurance Limited. Find out more about{' '}
                  <a href="https://autosure.co.nz/about-us/financial-strength/" target="_blank" rel="noopener noreferrer" style={styles.link}>Autosure's financial strength rating.</a>
                </p>

                <p style={{ marginTop: '20px' }}>
                  Autosure Insurance Limited is a member of the Financial Services Federation. Find out about their{' '}
                  <a href="https://docs.autosure.co.nz/docs/FSF_Responsible_Credit_Related_Insurance_Code.pdf " target="_blank" rel="noopener noreferrer" style={styles.link}>Responsible Credit-Related Insurance Code.</a>
                </p>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default MBILandingPage;
